import io from 'socket.io-client';
import React from 'react';
import { Api_Url } from '../redux/apiUrl';

const SOCKET_URL = Api_Url;

export const socket = io.connect(SOCKET_URL);

export const AppContext = React.createContext();
